var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "8px",
    viewBox: "0 0 7 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-less") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insights---overview",
    transform: "translate(-562.000000, -190.000000)",
    fill: "#CB52B0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "icon-less",
    transform: "translate(565.394000, 194.000000) scale(1, -1) translate(-565.394000, -194.000000) ",
    points: "564.994 191.5312 562.5656 193.9596 562 193.394 565.394 190 565.6768 190.2828 568.788 193.394 568.2224 193.9596 565.794 191.5312 565.794 198 564.994 198"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLess);
export default __webpack_public_path__ + "static/media/icon-less.b968349ba2c0c7f6c3cd9ba18095d404.svg";
export { ForwardRef as ReactComponent };